import React from "react";

import L from 'leaflet'
import MarkerClusterGroup from "react-leaflet-cluster";
import {FeatureGroup, Marker, Tooltip} from "react-leaflet";


// NOTE: iconCreateFunction is running by leaflet, which does not support ES6 arrow func syntax
// eslint-disable-next-line
const createClusterCustomIcon = function (cluster) {
    return new L.DivIcon({
        className: 'marker-cluster marker-cluster-primary',
        html: '<div><span>' + cluster.getChildCount() + '</span></div>',
        iconSize: new L.Point(40, 40)
    });
}

const getSelectedIcon = function () {
    return new L.Icon.Default({className: "marker-selected"});
}

const renderPropertyId = (feature) => {
    const {properties} = feature;
    return properties?.id
}


const GeoJSONPointsCollection = ({
                                     featureCollection,
                                     cluster = false,
                                     onFeatureClick = f => f,
                                     renderFeatureTooltip = renderPropertyId,
                                     clusterIconFn = createClusterCustomIcon,
                                     markerIconFn,
                                     getSelectedFeatures = null,
                                     clusterGroupProps = {}
                                 }) => {
    const features = featureCollection?.features ?? [];
    const {
        showCoverageOnHover=true,
        maxClusterRadius=40,
        ...clusterProps
    } = clusterGroupProps;

    const [selected, other] = getSelectedFeatures ? getSelectedFeatures(features) : [[], features];

    return <FeatureGroup>
        {
            cluster ? <MarkerClusterGroup chunkedLoading
                                          showCoverageOnHover={showCoverageOnHover}
                                          maxClusterRadius={maxClusterRadius}
                                          iconCreateFunction={clusterIconFn}
                                          {...clusterProps}>
                    <PointsCollection points={other}
                                      onMarkerClick={onFeatureClick}
                                      markerIconFn={markerIconFn}
                                      renderTooltip={renderFeatureTooltip}/>
                </MarkerClusterGroup>
                :
                <PointsCollection points={other}
                                  onMarkerClick={onFeatureClick}
                                  markerIconFn={markerIconFn}
                                  renderTooltip={renderFeatureTooltip}/>
        }

        <PointsCollection points={selected}
                          onMarkerClick={onFeatureClick}
                          renderTooltip={renderFeatureTooltip}
                          markerIconFn={() => getSelectedIcon()}/>
    </FeatureGroup>
}

const PointsCollection = ({points, onMarkerClick, renderTooltip, markerIconFn}) => {
    return <>
        {
            points.map(point => (
                <Marker key={point.properties.id}
                        feature={point}
                        position={[point.geometry.coordinates[1], point.geometry.coordinates[0]]}
                        eventHandlers={{
                            click: (e) => onMarkerClick(point, e),
                        }}
                        {...(markerIconFn ? {icon: markerIconFn(point)} : {})}
                >
                    <Tooltip>{renderTooltip(point)}</Tooltip>
                </Marker>
            ))
        }
    </>
}

export default GeoJSONPointsCollection;